import React, {useEffect, useState} from "react";
import {useQueryFilter, useSetIdDip} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";
import {RMLLavoratoreFilterSelection, useGetRetribuzioniByElementiQuery, useLazyGetRetribuzioniByElementiQuery} from "@commons/features/lavoratore/RMLLavoratore.api";
import {useGetElementiXSelezioneQuery} from "@commons/features/lavoratore/elemitiRMLSelezionati.api";
import DettaglioRetribuzione from "./comps/DettaglioRetribuzione";
import TabellaMensileRML from "./comps/TabellaMensilita";
import {TabProps} from "../Lavoratori.retrib.page";
import AreaSelezioneElementiRML from "./comps/AreaSelezioneElementiRML";
import TooltipEx from "../../../components/Tooltip";
import {export2excel} from "../../../features/export";
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";

export const TabByElementi: React.FC<TabProps> = ({editor, dettagliContratto, retribOraria, toggleRetribOraria}) => {
    const pagination = usePagination('',1, 10);
    const setPage = pagination.setPage;
    const [nowId, setNowId] = useState<string | null>(null);
    const {filter, setFilter, skip} = useQueryFilter<RMLLavoratoreFilterSelection>({} as RMLLavoratoreFilterSelection, pagination);
    const [elementiSelezionati, setElementiSelezionati] = useState<ElementoRMLSelezionabileRecord[]>([]);

    const {resource, cancel, URI, loadResource} = editor;
    // Imposto ID_DIP tra i parametri necessari alla query...
    useSetIdDip(dettagliContratto, setFilter, cancel);
    // Imposto <nowId> per forzare il reload al variare degli elementi!
    useEffect(() => {
        setFilter(filter => ({
            ...filter, nowId: nowId
        }));
    }, [setFilter, nowId]);

    // **************************************************************************************
    // Query per prelievo elementi retributivi utilizzati dal lavoratore utili alla selezione
    const {data} = useGetElementiXSelezioneQuery({idDip: filter.idDip}, {skip});

    // *******************************************************************************************
    // Query delle retribuzioni mensili in cui è variato uno o più elementi tra quelli selezionati
    // La query NON viene eseguita se non ci sono elementi selezionati!!!
    const {data: retribuzioneByElementi} = useGetRetribuzioniByElementiQuery(filter, {skip: (skip || elementiSelezionati.length === 0)});
    //console.log('isUninitialized', isUninitialized, 'isLoading', isLoading, 'isFetching', isFetching);

    // Al variare di <elementiSelezionati> forzo refetch reinizializzando nowId
    useEffect(() => {
        if (elementiSelezionati.length>0){
        setPage(1);
        const nowId = ((new Date()).getTime());
        setNowId(Number(nowId).toString());}
    }, [setPage, elementiSelezionati]);

    const [exportTrigger, {isLoading: exportIsLoading, isFetching: exportIsFetching}] = useLazyGetRetribuzioniByElementiQuery();
    const exportRML = () => export2excel(exportTrigger, filter, 'Elenco RML per elementi');

    return <>
        <div className="px-6 pt-6">
            <AreaSelezioneElementiRML data={data} onChange={setElementiSelezionati}/>
        </div>

        {resource && <div className="p-3">
            <DettaglioRetribuzione
                dettagliContratto={dettagliContratto}
                dettagliRetribuzione={resource}
                onCancel={cancel}
                mostraRetribOraria={retribOraria}
                toggleRetribOraria={toggleRetribOraria}/>
        </div>}

        <div className="p-3">
            <TabellaMensileRML
                title="Retribuzione Mensile Lorda"
                datasource={retribuzioneByElementi}
                pagination={pagination}
                retribOraria={retribOraria}
                toggleRetribOraria={toggleRetribOraria}
                URI={URI}
                loadResource={loadResource}
                showSommaVoci
            />
            <div className="mt-3 flex flex-row justify-end">
                <TooltipEx tooltip={`Esporta in un file XLSX l'elenco delle RML`}>
                    <button
                        type="button"
                        className="bg-blue-600 btnPrimary"
                        onClick={exportRML}
                        disabled={exportIsLoading || exportIsFetching}
                    >
                        Export
                    </button>
                </TooltipEx>
            </div>
        </div>
    </>;

}
export default TabByElementi;